// extracted by mini-css-extract-plugin
export var SmallImage = "p_v";
export var aniSpin = "p_d";
export var image = "p_t";